module.exports = __webpack_public_path__ + "img/left.c0a3e767.png";